import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { PropTypes } from "prop-types";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
    marginTop: theme.spacing(3),
    "& .MuiOutlinedInput-root": {
      marginTop: 7,
      height: "42px",
    },
  },
}));

export const DropDown = ({
  data,
  state,
  label,
  onChange,
  name,
  width,
  classNameLabel,
  classNameSelect,
}) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };
  const getCurrentId = (item) => {
    if (name === "Focus Area") {
      return item.focusAreaId;
    }
    return item.id;
  };

  const isPlaceHolder = (item) =>
    /Focus Area/i.test(item.text) || /Sort By/i.test(item.text);

  return (
    <FormControl
      margin="normal"
      variant="outlined"
      className={classes.formControl}
      style={{ width }}
    >
      <InputLabel id="cmdMaritalStatus" className={classNameLabel}>
        {label}
      </InputLabel>
      <Select
        labelId="cmdMaritalStatus"
        id="demo-controlled-open-select"
        open={open}
        onClose={handleClose}
        onOpen={handleOpen}
        value={state}
        onChange={onChange}
        name={name}
        className={classNameSelect}
      >
        {data.map((item) => {
          return (
            <MenuItem
              value={getCurrentId(item)}
              key={getCurrentId(item)}
              disabled={isPlaceHolder(item)}
            >
              {name === "Focus Area" ? item.name : item.text}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
DropDown.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  label: PropTypes.string,
  state: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  width: PropTypes.string,
  classNameLabel: PropTypes.string,
  classNameSelect: PropTypes.string,
};
DropDown.defaultProps = {
  label: "",
  width: "100%",
  classNameLabel: "",
  classNameSelect: "",
};
